import { Button, Link, Stack, Typography } from '@mui/joy'
import useStyleChatBotAlert from './utils/useStyleChatBotAlert'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import dayjs from 'dayjs'
import useChatBotAlert from './utils/useChatBotAlert'
import { TypeChatBotProps } from './utils/types'

const ChatBotAlert = (props: TypeChatBotProps) => {

  const { useStatic, } = props

  const {
    expand,
    setExpand,
    statusMessage,
    link,
    examMessages,
  } = useChatBotAlert(props)

  const style = useStyleChatBotAlert({ ...props, expand })

  return (
    <>
      {
        statusMessage &&
        <Stack sx={style.main}>
          <Stack sx={style.container}>
            <Stack direction="row" sx={{ flex: 1 }}>
              <Stack sx={{ width: 70, height: 70, flexShrink: 0 }}>
                <img src="/avatar-woman-cs-1.png" alt='Image chat bot profile picture' />
              </Stack>
              <Stack sx={style.chatLog}>
                {
                  (examMessages &&
                    examMessages?.length > 0) ?
                    examMessages.map((item, index) => (
                      <Stack key={index} sx={style.content}>
                        <Stack className="talk-bubble tri-right left-top">
                          <Stack className="talktext" sx={{ flexDirection: 'row', gap: 2, minWidth: 'min(80vw, 250px)', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography sx={style.text} level='body-sm'>{item.message}</Typography>
                            <Typography sx={style.textSubtitle} level='body-xs'>
                              {dayjs(item.timestamp).format('DD MMM YYYY HH:mm')}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    ))
                    : statusMessage ? (
                      <Stack sx={style.content}>
                        <Stack className="talk-bubble tri-right left-top">
                          <Stack className="talktext" sx={{ flexDirection: 'row', gap: 2, minWidth: 'min(80vw, 250px)', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography sx={style.text} level='body-sm'>
                              {statusMessage}
                              {
                                link &&
                                <Link href={link.href} target='_blank'>
                                  <Typography ml={0.5} className='heartbeat' component='span' sx={style.textLink} level='body-sm'>{link?.label}</Typography>
                                </Link>
                              }
                            </Typography>
                            {
                              !useStatic &&
                              <Typography sx={style.textSubtitle} level='body-xs'>{dayjs().format('DD MMM YYYY HH:mm')}</Typography>
                            }
                          </Stack>
                        </Stack>
                      </Stack>
                    ) : null
                }
              </Stack>
            </Stack>

            {/* Right side with expand/collapse button */}
            {
              !useStatic &&
              <Button sx={style.expand} variant='soft' onClick={() => setExpand(!expand)}>
                {
                  expand ?
                    <ExpandLess />
                    :
                    <ExpandMore />
                }
              </Button>
            }
          </Stack>
        </Stack>
      }
    </>
  )
}

export default ChatBotAlert
